import React, { useState } from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import PropTypes from "prop-types";
import styled from "styled-components";
import { LoadingSpinnerButton, PathwayButton } from "./PathwayButtons";
import { ErrorMessage } from "./Alerts/PathwayAlertMessages";

export const Modal3Options = (props) => {
    const [deleteClicked, setDeleteClicked] = useState(false);

    const handlePrimarySubmit = (e) => {
        props.handlePrimarySubmit(e);
        if (props.submitAndToggle) {
            props.toggleModal();
        }
    };

    const handleSecondarySubmit = () => {
        props.handleSecondarySubmit();
        if (props.submitAndToggle) {
            props.toggleModal();
        }
        if (props.secondaryIsDelete) {
            setDeleteClicked(false);
        }
    };

    return (
                <Modal isOpen={props.isOpen} toggle={props.toggleModal} size={props.size}>
            <ModalHeader toggle={props.toggleModal}>{props.title}</ModalHeader>
            <ModalBody>
                <ErrorMessage>{props.errorMessage}</ErrorMessage>
                {props.children}
            </ModalBody>
            <ModalFooterRow>
                {!props.hideSecondaryOption && (
                    <>
                        {!props.secondaryIsDelete ? (
                            <LoadingSpinnerButton
                                loading={props.isLoading}
                                disabled={props.disabled}
                                onClick={handleSecondarySubmit}
                            >
                                {props.secondaryButtonText}
                            </LoadingSpinnerButton>
                        ) : deleteClicked ? (
                            <LoadingSpinnerButton
                                color="danger"
                                loading={props.isLoading}
                                disabled={props.disabled}
                                onClick={handleSecondarySubmit}
                            >
                                Wirklich löschen?
                            </LoadingSpinnerButton>
                        ) : (
                            <LoadingSpinnerButton
                                color="danger"
                                loading={props.isLoading}
                                disabled={props.disabled}
                                onClick={() => setDeleteClicked(true)}
                            >
                                Löschen
                            </LoadingSpinnerButton>
                        )}
                    </>
                )}

                <PathwayButton color="secondary" onClick={props.toggleModal}>
                    Abbrechen
                </PathwayButton>

                {!props.hidePrimaryOption && (
                    <LoadingSpinnerButton
                        loading={props.isLoading}
                        onClick={handlePrimarySubmit}
                        color={props.primaryButtonColor ? props.primaryButtonColor : "primary"}
                        disabled={props.disabled}
                        buttonCyData={props.buttonCyData}
                    >
                        {props.primaryButtonText}
                    </LoadingSpinnerButton>
                )}
            </ModalFooterRow>
        </Modal>
    );
};

Modal3Options.propTypes = {
    children: PropTypes.element.isRequired,
    disabled: PropTypes.bool.isRequired,
    handlePrimarySubmit: PropTypes.func.isRequired,
    handleSecondarySubmit: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
    isOpen: PropTypes.bool.isRequired,
    errorMessage: PropTypes.string,
    primaryButtonText: PropTypes.string.isRequired,
    primaryButtonColor: PropTypes.string,
    secondaryIsDelete: PropTypes.bool,
    secondaryButtonText: PropTypes.string,
    hideSecondaryOption: PropTypes.bool,
    hidePrimaryOption: PropTypes.bool,
    size: PropTypes.any,
    title: PropTypes.string.isRequired,
    toggleModal: PropTypes.func.isRequired,
    buttonCyData: PropTypes.string,
};

// The buttons were spread to the footer's edges by an auto-fit grid, and cancel came last so it
// sat rightmost — the reverse of the prototype, which ends on the committing action. A
// destructive option keeps its distance on the left, where it cannot be hit by accident.
const ModalFooterRow = styled(ModalFooter)`
    display: flex;
    justify-content: flex-end;
    gap: 10px;

    > *:first-child:not(:last-child) {
        margin-right: auto;
    }
`;
